import {
  NavLink,
  type NavLinkProps,
  NavLinkWC,
} from '@pypestream/design-system';
import {
  type TransKeyProp,
  TranslationComponent,
  type TranslationKeys,
} from '@pypestream/translations';
import React from 'react';
import {
  type NavLinkProps as NavLinkPropsReactRouter,
  useHref,
  useLinkClickHandler,
} from 'react-router';

export const NavLinkWrapper = React.forwardRef<
  NavLinkProps,
  TransKeyProp &
    NavLinkPropsReactRouter & {
      onClick?: React.MouseEventHandler<NavLinkWC>;
      children?: React.ReactNode;
      isActive?: boolean;
      disabled?: boolean;
      external?: boolean;
      label?: string;
    }
>(
  (
    {
      label,
      onClick,
      replace = false,
      state,
      target,
      to,
      children,
      i18nKey,
      isActive = false,
      disabled = false,
      external = false,
    },
    ref
  ) => {
    const href = useHref(to);
    const handleClick = useLinkClickHandler<NavLinkWC>(to, {
      replace,
      state,
      target,
    });

    return (
      <NavLink
        test-id={`nav-link-${label?.toLowerCase()}`}
        active={isActive}
        href={external ? String(to) : href}
        onClick={(event: React.MouseEvent<NavLinkWC, MouseEvent>) => {
          if (!external) {
            onClick?.(event);
            if (!event.defaultPrevented && !disabled) {
              handleClick(event);
            }
          }
        }}
        ref={ref}
        target={target}
        disabled={disabled}
      >
        {i18nKey ? (
          <TranslationComponent i18nKey={i18nKey as TranslationKeys}>
            {children}
          </TranslationComponent>
        ) : (
          children
        )}
      </NavLink>
    );
  }
);
